import { Globe2, Code } from 'lucide-react'
import { CURRENT_CLIENT, getPageHeader } from '@/constants'
import { getPluginSlots } from '@/plugin/slots'
import { PageContainer } from './ui/page-container'
import { PageHeader } from './ui/page-header'
import { PageHeaderLeading } from '@/components/navigation/page-header-leading'
import { OnboardingSetupCard } from './onboarding/onboarding-setup-card'
import { PlatformDashboardSections } from '@/components/platform/platform-dashboard-sections'
import { DeveloperDashboardSections } from '@/components/developer/developer-dashboard-sections'

interface FocusDashboardProps {
  focus: string
  onStartConversation?: (message: string) => void
}

function PlatformDashboard({ onStartConversation }: { onStartConversation?: (message: string) => void }) {
  return (
    <PageContainer>
      <OnboardingSetupCard className="mb-6" onAskAgent={onStartConversation} />
      <PageHeader
        leading={<PageHeaderLeading />}
        {...getPageHeader('/platform', 'Platform Dashboard', 'Your users and platform activity at a glance')}
        icon={<Globe2 className="h-5 w-5" />}
      />

      <PlatformDashboardSections basePath="/platform" />
    </PageContainer>
  )
}

function DeveloperDashboard({ onStartConversation }: { onStartConversation?: (message: string) => void }) {
  return (
    <PageContainer>
      <OnboardingSetupCard className="mb-6" onAskAgent={onStartConversation} />
      <PageHeader
        leading={<PageHeaderLeading />}
        {...getPageHeader('/developer', 'Developer Dashboard', 'Agent evaluations and observability')}
        icon={<Code className="h-5 w-5" />}
      />
      <DeveloperDashboardSections />
    </PageContainer>
  )
}

export function FocusDashboard({ focus, onStartConversation }: FocusDashboardProps) {
  const Home = getPluginSlots().focusRegistrations.find((r) => r.focus === focus)?.home
  if (Home) {
    return <Home onStartConversation={onStartConversation} />
  }
  switch (focus) {
    case 'platform':
      return <PlatformDashboard onStartConversation={onStartConversation} />
    case 'developer':
      return <DeveloperDashboard onStartConversation={onStartConversation} />
    case 'client':
    case 'engineer':
    case 'principal':
      return (
        <PageContainer>
          <PageHeader leading={<PageHeaderLeading />} />
          <div className="flex items-center justify-center py-12">
            <div className="text-center text-muted-foreground">
              <p className="text-lg font-medium mb-2">Welcome to {CURRENT_CLIENT.name}</p>
              <p className="text-sm">
                Use the agent to continue — a dedicated {focus} home is coming soon.
              </p>
            </div>
          </div>
        </PageContainer>
      )
    default:
      return (
        <PageContainer>
          <PageHeader leading={<PageHeaderLeading />} />
          <div className="flex items-center justify-center py-12">
            <div className="text-center text-muted-foreground">
              <p className="text-lg font-medium mb-2">Welcome to {CURRENT_CLIENT.name}</p>
              <p className="text-sm">Please select a focus to get started</p>
            </div>
          </div>
        </PageContainer>
      )
  }
}
